import styled from 'styled-components';

import theme from '../../styles/theme';

export const Container = styled.div`
  display: none;
  flex: 1;
  height: 1500px;
  background-color: ${theme.faqBrackground};
  justify-content: center;
  align-items: center;

  @media (min-width: 860px) {
    display: flex;
  }
`;

export const TimelineWrapper = styled.div`
  display: flex;
  flex: 1;
  flex-direction: column;
  position: relative;
`;

export const TimelineItem = styled.div`
  display: flex;
  position: relative;
  flex: 1;
  flex-direction: ${({ right }) => (right ? 'row-reverse' : 'row')};
`;

export const TimelineBox = styled.div`
  display: flex;
  background-color: ${theme.background};
  max-height: 120px;
  max-width: 480px;
  height: 110px;
  justify-content: center;
  align-items: center;
  padding: 0 40px;
  text-align: center;
  font-size: 18px;

  ${({ right }) => {
    if (right) {
      return `
        border-top-right-radius: 80px;
        border-bottom-right-radius: 80px;
      `;
    }

    return `
      border-top-left-radius: 80px;
      border-bottom-left-radius: 80px;
    `;
  }}
`;

export const Divider = styled.div`
  display: flex;
  position: relative;
  flex: 1;
  width: 100%;
  margin: 40px;
  justify-content: ${({ right }) => (right ? 'flex-start' : 'flex-end')};
`;

export const TimelineDot = styled.div`
  display: flex;
  position: absolute;
  top: 50%;
  left: 50%;
  margin: auto;
  transform: translate(-50%, -50%);
  z-index: 2;
  justify-content: center;
  align-items: center;
  font-size: 60px;
  height: 120px;
  width: 120px;
  border-radius: 100%;
  border: 10px solid ${theme.primaryDarker};
  background-color: ${theme.primary};
`;

export const VerticalLine = styled.div`
  border-left: 2px solid ${theme.background};
  height: 90%;
  position: absolute;
  left: 50%;
  margin-left: -1px;
  top: 50%;
  transform: translateY(-50%);
`;

export const TimeLineLink = styled.a`
  color: ${theme.accent};
  text-decoration: none;
`;

export const LinkHighlight = styled.b`
  color: ${theme.primary};
`;
